import moment from 'moment';

export const paymentInfoAdapter = (data) => {
	return [
		{
			key: data?.order?.[0]?._id,
			payment_method_name: data?.order?.[0]?.payment_method_name || '-',
			createdAt: moment.unix(data?.order?.[0]?.createdAt).format('DD/MM/YYYY HH:mm:ss A') || '-',
			total: data?.order?.[0]?.total || '-',
			token: data?.order?.[0]?.payment_gateway_info?.token || '-',
			status: data?.order?.[0]?.status || '-',
			id_transaction: data?.tracking?.[0]?.pos?.id_transaction || '-',
			total_delivery: data?.order?.[0]?.total_delivery,
			sub_total: data?.order?.[0]?.sub_total + data?.order?.[0]?.total_discount || '-',
			payment_tracking: data?.payment_tracking || null,
		},
	];
};
